<template id="quizDetail">
    <v-ons-page>
        <v-ons-toolbar class="toolbarBack">
            <div class="left">
                <v-ons-toolbar-button @click="$router.push('/quiz')" class="back-icon"></v-ons-toolbar-button>
            </div>
            <div class="center toolbar-alignMent">
                <div>
                    <img class="verticallyMiddle" alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 22px;height: 22px"/>
                </div>
                &nbsp;<div class="predictWinWrapper">{{text.taliWaGali}}</div>
            </div>
            <div class="right" v-if="allResponse">
                <div style="display: inline-flex">
                    <div v-if="allResponse && quizDetail.status==='Published'">
                    <span v-if="totalParticipants && totalParticipants>=1">
                        <span class="colorWhite font14px votesHeader">{{countValue(totalParticipants)}} {{text.voted}}</span>
                    </span>
                    </div>
                    <div v-if="quizDetail.status==='Result' || quizDetail.status==='Completed'">
                    <span v-if="totalParticipants && totalParticipants>=1">
                        <span class="colorWhite font14px votesHeader">{{countValue(totalParticipants)}} {{text.voted}}</span>
                    </span>
                    </div>
                    <span v-if="isLogin">
                    <v-ons-toolbar-button class="chat-icon" @click="$router.push('/chat/'+userId)"></v-ons-toolbar-button>
                    </span>
                </div>
            </div>
            <div v-else class="right">
                <v-ons-toolbar-button class="refresh" @click="refresh()"></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>
        <v-ons-pull-hook
                :action="pullItems"
                @changestate="state = $event.state"
        >
            <span v-show="state === 'initial'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="20"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'preaction'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="40"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'action'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="100"></v-ons-progress-circular>
            </span>
        </v-ons-pull-hook>
        <v-ons-toast :visible.sync="showSnack">
            {{snackBarMsg}}
            <button @click="showSnack = false"><i class="zmdi zmdi-close"></i>
            </button>
        </v-ons-toast>
        <p class="text-center">
            <v-ons-progress-circular class="refreshButton" indeterminate v-if="loading"></v-ons-progress-circular>
        </p>
        <div>
            <div class="detailPage" v-if="allResponse">
                <div v-if="allResponse.participant" class="resultWrapper">
                    <div v-if="quizDetail.status==='Result'">
                        <div>
                            <div class="resultBox" v-if="isWinner">
                                <div class="text-center">
                                    <div class="padding10px">
                                        <img alt="wow!!" class="" src="../assets/winner.svg">
                                    </div>
                                    <div>
                                        <span class="resultMessageText">{{text.congratulation}}!!!</span>
                                        <div>
                                            {{text.winningMsg}}
                                        </div>
                                        <div>{{rewardDetail.name}}</div>
                                        <br>
                                        <div v-if="rewardDetail.sponsor">
                                            <span class="font14px">{{text.sponsoredBy}}: {{rewardDetail.sponsor.name}} </span>
                                            <a :href="rewardDetail.sponsor.link" target="_blank">
                                                <img :src="rewardDetail.sponsor.img" alt="sponsor-image" class="sponsorImg"/></a>
                                        </div>
                                        <div>
                                            <div class="contactWrapper">
                                                <button class="button--large--cta claimButton">{{text.shareIt}}</button>
                                                <button @click="$router.push('/quiz')" class="button--large--cta claimButton"><v-ons-toolbar-button
                                                        class="chat">
                                                </v-ons-toolbar-button>{{text.contactUs}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="resultBox" v-else>
                                <div class="text-center">
                                    <div class="padding10px">
                                        <img alt="ohh!!" class="" src="../assets/winner.svg">
                                    </div>
                                    <div>
                                        <span class="resultMessageText">{{text.thankYou}}!!</span>
                                        <div>
                                            {{text.thankYouMsg}}
                                        </div>
                                        <br>
                                        <div>
                                            {{text.greetingThanks}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="quizDetail.status==='Result'">
                    <div @click="pushToWinners(quizDetail.question,$route.params.questionId,'quiz-winners')">
                        <img src="../assets/taali_wa_gaali_notification-winners.png" alt="winners-list" style="width: 100%; border-radius: 10px">
                    </div>
                </div>
                <div>
                    <div style="width: 75%; margin: auto">
                        <img src="../assets/tali_wa_gali.png" alt="winners-list" style="width: 100%; border-radius: 10px">
                    </div>
                </div>
                <div class="colorWhite questionTitle">
                    <p>{{quizDetail.title}}</p>
                </div>
                <v-ons-card class="marginLeftRightNone paddingNone timerCard">
                    <div class="quizTime">
                        <div class="floatLeft">
                            <v-ons-toolbar-button
                                    class="timer">
                            </v-ons-toolbar-button>
                        </div>
                        <div v-if="quizDetail.status==='Published'">
                            <CountDown :date=quizDetail.endTime/1000 ></CountDown>
                        </div>
                        <div class="text-center colorWhite timeStartEnd" v-else>{{text.votingEnded}}</div>
                    </div>
                    <div class="quesTextWrapper">
                        <span class="quesText">{{quizDetail.question}}</span>
                    </div>
                    <div class="optionWrapper">
                        <div v-if="quizDetail.status==='Published'">
                            <div>
                                <!--                                <div v-if="allResponse.participant">-->
                                <!--                                    <div v-bind:key="option" v-for="(option,key) in quizDetail.options">-->
                                <!--                                        <div :class="allResponse.participant.answer === option ? ' optionButton colorBlack optionSelected' : option.includes('गाली') ? 'optionGaliButton colorBlack' : 'optionButton colorBlack' ">-->
                                <!--                                            <span class="padding1015px textBold font16px">{{option}}</span><span-->
                                <!--                                                v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</span>-->
                                <!--                                            <span class="floatRight paddingRight10px font10px" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div v-if="allResponse.participant" class="inlineFlex fullWidth">
                                    <div v-for="(option) in quizDetail.options" v-bind:key="option" style="width: 47%; margin: 3px">
                                        <div>
                                            <div v-if="allResponse.participant.answer === option" class="voteWrapper">
                                                <span class="vote">YOU VOTED</span>
                                            </div>
                                            <div v-else class="voteWrapper">
                                                <span class="vote">&nbsp;</span>
                                            </div>
                                            <div :style="allResponse.optionCounters[option]>=0.1 ? calculateBackgroundSize((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2)) : 'calculateDefaultBackgroundSize'" :class="option.includes('गाली') ? 'previousOptionGali colorBlack backgroundGali' : 'previousOptionTali colorBlack backgroundTali' ">
                                        <span class="padding10px textBold font16px centerInlineFlex"><v-ons-toolbar-button :class="option.includes('गाली') ? 'dislike-icon-after' : 'like-icon-after' "></v-ons-toolbar-button> {{option}}
                                        <div class="floatRight votePerc" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</div></span>
                                            </div>
                                            <div v-if="allResponse.optionCounters[option]>=1" class="text-center">
                                                <span class="votes">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="useSession" class="inlineFlex fullWidth">
                                    <div v-for="(option) in quizDetail.options" v-bind:key="option" style="width: 47%; margin: 3px" class="new">
                                        <div>
                                            <div v-if="selectedOption===option" class="voteWrapper">
                                                <span class="vote">YOU VOTED</span>
                                            </div>
                                            <div v-else class="voteWrapper">
                                                <span class="vote">&nbsp;</span>
                                            </div>

                                            <div>
                                                <div :class="selectedOption===option ? option.includes('गाली') ? 'optionBeforeButton optionGaliSelected': 'optionBeforeButton optionTaliSelected' : 'optionBeforeButton colorBlack' ">
                                                    <span class="padding10px textBold font16px centerInlineFlex"><v-ons-toolbar-button :class="option.includes('गाली') ? 'dislike-icon-after' : 'like-icon-after' "></v-ons-toolbar-button> {{option}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="inlineFlex fullWidth">
                                    <div v-for="(option) in quizDetail.options" v-bind:key="option" style="width: 47%; margin: 3px">
                                        <div>
                                            <div v-if="selectedOption===option" class="voteWrapper">
                                                <span class="vote">YOU VOTED</span>
                                            </div>
                                            <div v-else class="voteWrapper">
                                                <span class="vote">&nbsp;</span>
                                            </div>
                                            <div>
                                                <div :class="selectedOption===option ? option.includes('गाली') ? 'optionBeforeButton optionGaliSelected': 'optionBeforeButton optionTaliSelected' : 'optionBeforeButton colorBlack' " @click="saveOption(option,key)">
                                                    <span class="padding10px textBold font16px centerInlineFlex"><v-ons-toolbar-button :class="option.includes('गाली') ? 'dislike-icon-after' : 'like-icon-after' "></v-ons-toolbar-button> {{option}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--                            <div class="block" v-if="!allResponse.participant && !useSession">-->
                            <!--                                <button @click="saveUserOption()"-->
                            <!--                                        :class="selectedOption ? 'button&#45;&#45;large&#45;&#45;cta  saveOptionButton' : 'button&#45;&#45;large&#45;&#45;cta  beforeSaveButton'"><span class="padding1015px">{{text.submit}}</span>-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                        </div>
                        <div v-else-if="quizDetail.status==='Result'">
                            <div>
                                <div v-if="allResponse.participant">
                                    <div v-if="quizDetail.correctOption === allResponse.participant.answer">
                                        <div v-for="(option) in quizDetail.options" v-bind:key="option">
                                            <div :class="allResponse.participant.answer === option ? ' optionButton colorBlack correctOption' : option.includes('गाली') ? 'optionGaliButton colorBlack' : 'optionButton colorBlack'">
                                                <span class="padding1015px textBold font14px">{{option}} </span>
                                                <span v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</span>
                                                <span class="floatRight paddingRight10px font10px" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                                <!--                                                <span class="floatRight" v-if="quizDetail.correctOption===option"><v-ons-toolbar-button-->
                                                <!--                                                        class="done"></v-ons-toolbar-button></span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="(option) in quizDetail.options" v-bind:key="option">
                                            <div :class="allResponse.participant.answer === option ? ' optionButton colorBlack incorrectOption' : option.includes('गाली') ? 'optionGaliButton colorBlack' : 'optionButton colorBlack'">
                                                <span class="padding1015px textBold font14px">{{option}} </span>
                                                <span v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</span>
                                                <span class="floatRight paddingRight10px font10px" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                                <!--                                                <span class="floatRight" v-if="quizDetail.correctOption===option"><v-ons-toolbar-button-->
                                                <!--                                                        class="done"></v-ons-toolbar-button></span>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-for="(option) in quizDetail.options" v-bind:key="option">
                                        <div :class="option.includes('गाली') ? 'optionGaliButton colorBlack' : 'optionButton colorBlack'">
                                            <span class="padding1015px textBold font14px">{{option}} </span>
                                            <span v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</span>
                                            <span class="floatRight paddingRight10px font10px" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                            <!--                                            <span class="floatRight" v-if="quizDetail.correctOption===option"><v-ons-toolbar-button-->
                                            <!--                                                    class="done"></v-ons-toolbar-button></span>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="quizDetail.status==='Completed'">
                            <!--                            <div v-if="allResponse.participant">-->
                            <!--                                <div v-bind:key="option"-->
                            <!--                                     v-for="(option) in quizDetail.options">-->
                            <!--                                <span :class="allResponse.participant.answer === option ? ' optionButton colorBlack optionSelected' : option === 'गाली' ? 'optionGaliButton colorBlack' : 'optionButton colorBlack'">-->
                            <!--                                    <span class="padding1015px textBold font14px">{{option}}</span>-->
                            <!--                                    <span v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</span>-->
                            <!--                                     <span class="floatRight paddingRight10px font10px" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>-->
                            <!--                                    </span>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div v-if="allResponse.participant" class="inlineFlex fullWidth">
                                <div v-for="(option) in quizDetail.options" v-bind:key="option" style="width: 47%; margin: 3px">
                                    <div>
                                        <div v-if="allResponse.participant.answer === option" class="voteWrapper">
                                            <span class="vote">YOU VOTED</span>
                                        </div>
                                        <div v-else class="voteWrapper">
                                            <span class="vote">&nbsp;</span>
                                        </div>
                                        <div :style="allResponse.optionCounters[option]>=0.1 ? calculateBackgroundSize((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2)) : 'calculateDefaultBackgroundSize'" :class="option.includes('गाली') ? 'previousOptionGali colorBlack backgroundGali' : 'previousOptionTali colorBlack backgroundTali' ">
                                        <span class="padding10px textBold font16px centerInlineFlex"><v-ons-toolbar-button :class="option.includes('गाली') ? 'dislike-icon-after' : 'like-icon-after' "></v-ons-toolbar-button> {{option}}
                                        <div class="floatRight votePerc" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</div></span>
                                        </div>
                                        <div v-if="allResponse.optionCounters[option]>=1" class="text-center">
                                            <span class="votes">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="inlineFlex fullWidth">
                                <div v-for="(option) in quizDetail.options" v-bind:key="option" style="width: 47%; margin: 3px">
                                    <div>
                                        <div :style="allResponse.optionCounters[option]>=0.1 ? calculateBackgroundSize((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2)) : 'calculateDefaultBackgroundSize'" :class="option.includes('गाली') ? 'previousOptionGali colorBlack backgroundGali' : 'previousOptionTali colorBlack backgroundTali' ">
                                        <span class="padding10px textBold font16px centerInlineFlex"><v-ons-toolbar-button :class="option.includes('गाली') ? 'dislike-icon-after' : 'like-icon-after' "></v-ons-toolbar-button> {{option}}
                                        <div class="floatRight votePerc" v-if="allResponse.optionCounters[option]>=1">{{convertToNepali((((allResponse.optionCounters[option])/totalParticipants)*100).toFixed(2))}}%</div></span>
                                        </div>
                                        <div v-if="allResponse.optionCounters[option]>=1" class="text-center">
                                            <span class="votes">{{convertToNepali(allResponse.optionCounters[option])}} {{text.votes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-ons-card>
                <p class="colorWhite text-center font14px"><i>
                    <a
                            class="colorWhite" href="https://www.hamropatro.com/voting-terms"
                            target="_blank">* {{text.termsService}}</a></i>
                </p>
            </div>
            <div class="detailPage">
                <div v-if="checkingAns">
                    <div class="detailPage statusBox checkingAnsBox">
                        <div class="text-center colorWhite">
                            <div>
                                <div class="resultMessageText">{{text.submitting}}</div>
                                <br>
                                <ons-progress-circular indeterminate></ons-progress-circular>
                                <div class="floatRight checkingAnsImg">
                                    <img alt="checking!!" class="" src="../assets/checking_answer.svg">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="statusBox text-center colorWhite" v-else-if="useSession">
                    <div class="padding10px">
                        <img alt="double??" class="" src="../assets/ic_hamro_correct.svg">
                    </div>
                    <div>
                        <div>
                            {{text.greatJob}},
                        </div>
                        <div>
                            {{text.thankYouMsg}}
                        </div>
                        <br/>
                        <div style="font-size: 18px; padding: 5px 12px; margin: 5px 0 15px">{{text.votedLoginText}}</div>
                        <div>
                            <button class="button--large--cta loginButton" @click="loginNow()">{{text.loginNow}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div v-if="enabling2X">
                <div class="detailPage statusBox checkingAnsBox">
                    <div class="text-center colorWhite">
                        <div>
                            <div class="resultMessageText">{{text.enabling2x}}</div>
                            <br>
                            <ons-progress-circular indeterminate></ons-progress-circular>
                            <div class="floatRight checkingAnsImg">
                                <img alt="checking!!" class="" src="../assets/checking_answer.svg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="allResponse.participant">
                <div v-if="quizDetail.status!=='Result'">
                    <div class="detailPage statusBox" v-if="allResponse.participant.x2Entry">
                        <div class="text-center colorWhite">
                            <div class="padding10px">
                                <img alt="doubled!!" class="" src="../assets/2x_stamp.svg">
                            </div>
                            <div>
                                <span class="resultMessageText">{{text.yay}}!!</span>
                                <div>
                                    {{text.enabledMsg2x}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detailPage" v-else-if="!allResponse.participant.x2Entry && quizDetail.status==='Published'">
                        <div class="statusBox text-center colorWhite" v-if="!enabling2X">
                            <div class="padding10px">
                                <img alt="double??" class="" src="../assets/ic_hamro_correct.svg">
                            </div>
                            <div>
                                <div>
                                    {{text.greatJob}}, {{allResponse.participant.user.name}},
                                </div>
                                <div>
                                    {{text.before2x}}
                                </div>
                                <br>
                                <div>
                                    {{text.waitingResultMsg}}
                                </div>
                                <div class="padding10px">
                                    <span class="doubleWrapper">2x</span>
                                </div>
                                <span class="button--large--cta  currentButton" @click="dialogVisible = true"><span class="doubleChance">{{text.shareIssue}}</span></span>
                            </div>
                        </div>
                    </div>
                    <!--                    <div @click="dialogVisible=true">-->
                    <!--                        hello-->
                    <!--                    </div>-->
                    <!--                    sharing-->
                    <div>
                        <v-ons-dialog
                                cancelable
                                :visible.sync="dialogVisible"
                        >

                            <div style="padding: 10% 0;background-image: linear-gradient(#f8def9, #b6e0f5);">
                                <div style="text-align: center">
                                    <div>
                                        <img alt="quiz-image" src="../assets/2x_stamp.svg"
                                             style="width: 80px;height: 80px;"/>
                                    </div>
                                    <div class="whiteSpace" style="font-size: 18px; color:#797171; padding: 5px 12px; margin: 5px 0 15px; "> {{text.shareBoxMsg}}</div>
                                </div>
                                <social-sharing :url="'https://taligali.hamropatro.com/'+quizDetail.key+'/detail'"
                                                :title="'My Prediction is: '+allResponse.participant.answer+'. Express your vote. \n'+text_truncate(quizDetail.title,30)"
                                                :description="quizDetail.description"
                                                :quote="'My Vote is for : '+allResponse.participant.answer+'. Express your vote. \n'+text_truncate(quizDetail.title,30)"
                                                hashtags="hamropatro,gali,tali, gali_tali, sajhaSawal, rabiLamichanne"
                                                twitter-user="hamropatro"
                                                inline-template @close="close()">
                                    <div style="text-align: center; margin: 10px 0 5px">
                                        <network network="facebook">
                                            <span class="socialShare social-fa">
                                                <i class="fa fa-facebook fa-fw"></i>
                                            </span>
                                        </network>
                                        <network network="twitter">
                                             <span class="socialShare social-twit">
                                            <i class="fa fa-twitter"></i>
                                             </span>
                                        </network>
                                        <network network="linkedin">
                                            <span class="socialShare social-link">
                                                <i class="fa fa-linkedin"></i>
                                            </span>
                                        </network>
                                        <network network="pinterest">
                                             <span class="socialShare social-pin">
                                            <i class="fa fa-pinterest"></i>
                                             </span>
                                        </network>
                                        <network network="reddit">
                                             <span class="socialShare social-redd">
                                            <i class="fa fa-reddit"></i>
                                             </span>
                                        </network>
                                    </div>
                                </social-sharing>
                            </div>
                        </v-ons-dialog>
                    </div>
                </div>
            </div>
            <div class="imgWrapper169" v-if="allResponse">
                <img :src="quizDetail.image" alt="quiz-image" class="quizImage169">
            </div>
            <div v-if="allResponse">
                <div class="detailPage">
                    <h4 class="colorWhite font14px"><b>NEWS 24 Live</b></h4>
                </div>
                <div class="imgWrapper169" v-if="quizDetail.video">
                    <iframe :src="quizDetail.video"
                            class="quizImage169">
                    </iframe>
                </div>
            </div>
            <div class="detailPage" v-if="allResponse">
                <p class="colorWhite font14px"><span v-html="quizDetail.description"></span></p>

                <p class="text-center colorWhite winnersText"
                   v-if="quizDetail.status==='Result'">{{text.winners}}!!!</p>
                <v-ons-card class="marginLeftRightNone rewardCard" v-for="(value,key) in quizDetail.reward">
                    <div class="prizeName">
                        <span class="prizeText">{{value.name}}</span>
                    </div>
                    <div class="prizeDetail">
                        <span>{{value.description}}</span>
                    </div>
                    <div class="sponsorDetail">
                        <div v-if="value.sponsor">
                            <div class="sponsorBtmText">{{text.sponsor}}:</div>
                            <a :href="value.sponsor.link"
                               style="display: flex; line-height: 1.9; margin-top: 5px; text-decoration: none"
                               target="_blank">
                                <div>
                                    <img :src="value.sponsor.img" alt="sponsor-image"
                                         style="width: 25px;height: 25px; border-radius: 50%"/>
                                </div>
                                <div style="padding-left: 5px; font-size: 13px; color: #928a8a;"><span>{{value.sponsor.name}}</span>
                                </div>
                            </a>
                        </div>
                        <div class="" v-if="quizDetail.status==='Result'">
                            <ons-row>
                                <ons-col v-for="(item) in allResponse.winners[key+1]" class="text-center winnerWrapper">
                                    <div v-if="item.participant.user.img" class="participantImg">
                                        <img :src="item.participant.user.img" class="fullWidth"/>
                                    </div>
                                    <span v-else>{{firstLetter(item.participant.user.name)}}</span>
                                    <span class="top-right x2Item" v-if="item.participant.x2Entry">2x</span>
                                    <div class="participantName">{{item.participant.user.name}}</div>
                                </ons-col>
                            </ons-row>
                        </div>
                    </div>
                </v-ons-card>
                <div>
                    <v-ons-dialog
                            cancelable
                            :visible.sync="shareDialog"
                    >

                        <div style="padding: 10% 0;background-image: linear-gradient(#f8def9, #b6e0f5);">
                            <div style="text-align: center">
                                <div>
                                    <img alt="quiz-image" src="../assets/hamropatro.png"
                                         style="width: 80px;height: 80px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"/>
                                </div>
                                <div style="font-size: 18px; color:#797171; padding: 5px 12px; margin: 5px 0 15px"> {{text.voteShareMSG}}</div>
                            </div>
                            <social-sharing :url="'https://taligali.hamropatro.com/'+quizDetail.key+'/detail'"
                                            :title="text_truncate(quizDetail.title,45)"
                                            :description="quizDetail.description"
                                            :quote="text_truncate(quizDetail.title,30)"
                                            hashtags="hamropatro_vote,gali_tali,gali,tali,news24"
                                            twitter-user="hamropatro_dev"
                                            inline-template @close="closeShare()">
                                <div style="text-align: center; margin: 10px 0 5px">
                                    <network network="facebook">
                                            <span class="socialShare social-fa">
                                                <i class="fa fa-facebook fa-fw"></i>
                                            </span>
                                    </network>
                                    <network network="twitter">
                                             <span class="socialShare social-twit">
                                            <i class="fa fa-twitter"></i>
                                             </span>
                                    </network>
                                    <network network="linkedin">
                                            <span class="socialShare social-link">
                                                <i class="fa fa-linkedin"></i>
                                            </span>
                                    </network>
                                    <network network="pinterest">
                                             <span class="socialShare social-pin">
                                            <i class="fa fa-pinterest"></i>
                                             </span>
                                    </network>
                                    <network network="reddit">
                                             <span class="socialShare social-redd">
                                            <i class="fa fa-reddit"></i>
                                             </span>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                    </v-ons-dialog>
                </div>
                <div>
                    <v-ons-dialog
                            cancelable
                            :visible.sync="loginDialog"
                    >

                        <div style="padding: 10% 0;background-image: linear-gradient(#f8def9, #b6e0f5);">
                            <div style="text-align: center">
                                <div>
                                    <img alt="quiz-image" src="../assets/hamropatro.png"
                                         style="width: 80px;height: 80px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"/>
                                </div>
                                <div style="font-size: 18px; color:#797171; padding: 5px 12px; margin: 5px 0 15px"> {{text.votedLoginText}}</div>
                                <div>
                                    <button class="button--large--cta loginButton" @click="loginNow()">{{text.loginNow}}</button>
                                </div>
                            </div>
                        </div>
                    </v-ons-dialog>
                </div>
                <div class="flex">
                    <button class="button--large--cta resultButton" @click="shareDialog=true">{{text.shareIt}}</button>
                    <button @click="$router.push('/quiz')" class="button--large--cta resultButton">{{text.viewAll}}</button>
                </div>
            </div>
        </div>
    </v-ons-page>
</template>

<script>
    import {
        enabled2X,
        getQuizDetail,
        saveUserAnswer,
        saveWithoutLoginAnswer,
        totalParticipantCount
    } from '../api/requests/questions';
    import {trigetGoogleAnaystEvent} from "../config";
    import CountDown from "../components/CountDown";
    import {getUserID, isLogin, memberCountValue} from '../util/globalConfig';
    import usedText, {useNepali} from "../util/languageText";
    import {englishToNepali} from "../util/Common";
    import { Miniapp } from '../util/Miniapp';

    export default {
        name: 'QuizList',
        components: {CountDown},
        data: () => ({
            // forSnackbar
            showSnack: null,
            snackBarMsg: null,
            loading: true,
            quizDetail: '',
            state: 'initial',
            quizId: null,
            selectedOption: null,
            totalParticipants: 0,
            allResponse: null,
            isWinner:false,
            rewardDetail:null,
            checkingAns:false,
            enabling2X:false,
            dialogVisible: false,
            shareDialog: false,
            userId: '',
            text:usedText,
            isLogin: false,
            loginDialog:false,
            useSession:false,
        }),
        async created() {
            let self = this;
            const userDetails  = await Miniapp.getUserProfile();
            self.userDetails = userDetails;
            self.userId = userDetails != null ? userDetails.id : null;
            self.isLogin = userDetails.id != '';
            this.getItems();
        },
        computed:{

            // calculateBackgroundSize() {
            //     return {
            //         backgroundSize: `${30}% 100%`
            //     };
            // },
            calculateDefaultBackgroundSize() {
                return {
                    backgroundSize: `0% 0%`
                };
            },
        },
        methods: {
            calculateBackgroundSize: function (size) {
                return {
                    backgroundSize: `${size}% 100%`
                };
            },
            getItems() {
                //remove snackBar
                let self = this;
                this.getQuizById();
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            loginNow: function () {
                this.setSession();
                this.$router.push("/login?redirectURL=" + this.$route.params.questionId + "/detail");
            },
            getQuizById: function () {
                let self = this;
                self.loading = true;
                self.showSnack = false;
                self.allResponse = '';
                self.quizId = self.$route.params.questionId;
                getQuizDetail(self.quizId,5).then(function (response) {
                    if (response.success) {
                        self.allResponse = response.data;
                        trigetGoogleAnaystEvent(self.allResponse.quiz.question,'quiz-viewed','viewed- '+self.allResponse.quiz.question+ ' -'+ self.allResponse.quiz.key);
                        let sum= 0;
                        for (let value of Object.values(response.data.optionCounters)) {
                            sum=sum+value;
                        }
                        self.totalParticipants = sum;
                        self.loading = false;
                        if(self.allResponse.participant) {
                            self.isWinner = self.checkWinner(self.allResponse.participant, self.allResponse.winners);
                        }
                        self.quizDetail = self.allResponse.quiz;

                        if (self.isLogin) {
                            let userVoteData = sessionStorage.getItem('userVote');
                            let quizId=self.$route.params.questionId;
                            if (userVoteData && !self.allResponse.participant) {
                                let userVote = userVoteData.split(':')[1];
                                let voteId = userVoteData.split(':')[0];
                                if(quizId===voteId) {
                                    self.selectedOption = userVote;
                                    self.saveUserOption();
                                }
                            } else self.removeSession();
                        } else {
                            let userVoteData = sessionStorage.getItem('userVote');
                            let quizId=self.$route.params.questionId;
                            if (userVoteData) {
                                let userVote = userVoteData.split(':')[1];
                                let voteId = userVoteData.split(':')[0];
                                if(quizId===voteId) {
                                    self.selectedOption = userVote;
                                    self.useSession =true
                                }
                            }
                        }

                        if(sum<=0) self.getParticipantCount();

                    } else {
                        // show SnackBar
                        self.loading = false;
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loading = false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            saveOption: function (selectedOpt) {
                this.selectedOption = selectedOpt;
                this.saveUserOption();
            },
            setSession: function () {
                sessionStorage.setItem('userVote', this.$route.params.questionId + ':' + this.selectedOption);
            },
            removeSession :function () {
                sessionStorage.removeItem('userVote');
            },
            countValue :function(number) {
                return memberCountValue(number);
            },
            convertToNepali : function(englishNumber){
                if(useNepali)
                    return englishToNepali(englishNumber);
                else  return  englishNumber ;
            },
            saveUserOption: function () {
                if(!this.selectedOption) {
                    this.showSnack = true;
                    this.snackBarMsg = this.text.selectOne;
                    let self= this;
                    setTimeout(function () {
                        self.showSnack = false;
                    }, 2000);
                    return;
                }
                // if(!this.isLogin){
                //     this.loginDialog= true;
                //     return;
                // }
                let json = {
                    'quizID': this.$route.params.questionId,
                    'answer': this.selectedOption
                };
                let self = this;
                self.showSnack = false;
                self.checkingAns = true;
                if(self.isLogin) {
                    saveUserAnswer(json).then(function (response) {
                        self.loading = false;
                        self.checkingAns = false;
                        self.winnersId = null;
                        if (response.success) {
                            trigetGoogleAnaystEvent(self.allResponse.quiz.question, 'quiz-answered', 'answered- ' + self.selectedOption);
                            self.removeSession();
                            self.getItems();
                        } else {
                            // show SnackBar
                            // self.snackBarMsg = response.msg;
                            // self.showSnack = true;
                        }
                    }).catch(function (error) {
                        self.removeSession();
                        self.loading = false;
                        self.checkingAns = false;
                        // show SnackBar
                        // self.snackBarMsg = error.data.msg;
                        // self.showSnack = true;
                    });
                } else {
                    saveWithoutLoginAnswer(json).then(function (response) {
                        self.loading = false;
                        self.checkingAns = false;
                        self.winnersId = null;
                        self.setSession();
                        if (response.success) {
                            self.loginDialog = true;
                            trigetGoogleAnaystEvent(self.allResponse.quiz.question, 'quiz-answered-withoutLogin', 'answered- ' + self.selectedOption);
                            self.getItems();
                        }
                    }).catch(function (error) {
                        self.loading = false;
                        self.checkingAns = false;
                    });
                }
            },
            getParticipantCount:function(){
                let self = this;
                self.showSnack = false;
                self.totalParticipants = 0;
                self.quizId = self.$route.params.questionId;
                totalParticipantCount(self.quizId).then(function (response) {
                    if (response.success) {
                        self.totalParticipants = response.data;
                    }
                }).catch(function (error) {
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            firstLetter(title) {
                return title.charAt(0);
            },
            checkWinner(partipant,winners){
                let self=this;
                let isWinner=false;
                for(var key in winners){
                    var winnerObject=winners[key];
                    winnerObject.forEach(function (item) {
                        if(item.participant.user.userID===partipant.user.userID) {
                            isWinner= true;
                            self.rewardDetail=item.reward;
                            return isWinner;
                        }
                    })
                }
                return isWinner;
            },
            doubleChance:function(){
                let self = this;
                self.dialogVisible=false;
                self.enabling2X=true;
                self.loading = true;
                self.showSnack = false;
                self.quizId = self.$route.params.questionId;
                enabled2X(self.quizId).then(function (response) {
                    self.loading = false;
                    self.enabling2X=false;
                    if (response.success) {
                        trigetGoogleAnaystEvent(self.allResponse.quiz.question,'2x','2x-Enabled');
                        self.getItems();
                    } else {
                        // show SnackBar
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loading = false;
                    self.enabling2X=false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            refresh () {
                this.getItems();
            },
            pushToWinners(question,quizId,event){
                trigetGoogleAnaystEvent(question,'quizWinners',event);
                this.$router.push('/'+quizId+'/winners');
            },
            pullItems(done) {
                setTimeout(() => {
                    this.loading = true;
                    this.getItems();
                    done();
                }, 500);
            },
            text_truncate(str, length, ending) {
                if (length == null) {
                    length = 100;
                }
                if (ending == null) {
                    ending = '...';
                }
                if (str.length > length) {
                    return str.substring(0, length - ending.length) + ending;
                } else {
                    return str;
                }
            },
            close(){
                this.doubleChance();
            },
            closeShare(){
                this.shareDialog=false;
            }
        },
    }
</script>